export default __webpack_public_path__ + "static/Earth-Day-Sub-Banner-Desktop-87dfaf861f80122a8d0e0f5ac854ea3f.webp";